import type { NuxtApp } from '#app';

import type {
  IPageResponse,
  IResponse,
  RequestConfig,
  Star,
  StarRequest,
  Template,
  TemplateParams,
} from '../interface';
import { fetch } from '../request';

// 获取模板
export const getTemplateList = (params: TemplateParams, config?: any) => {
  return fetch<IPageResponse<Template>>('/youyan/template/get_sorted_template/', {
    method: 'GET',
    params,
    ...(config || {}),
  });
};

// 首页获取
export const getHomeTemplateLists = (
  params: TemplateParams,
  config?: RequestConfig,
  nuxtApp?: NuxtApp,
) => {
  return fetch<IPageResponse<Template>>(
    '/youyan/templates/',
    {
      method: 'GET',
      params,
      ...config,
    },
    nuxtApp,
  );
};

// 后台模板获取
export const getHomeTemplateList = (params: TemplateParams & { ids?: string }, app?: NuxtApp) => {
  return fetch<IResponse<Template[]>>(
    '/youyan/template/',
    {
      method: 'GET',
      params,
    },
    app,
  );
};

// 后台模板获取
export const getStudioList = () => {
  return fetch<IResponse<any[]>>('/tags/project_map_types/get_all_map_types/', {
    method: 'GET',
  });
};

export const internalShare = (body: { link: string; account_id?: number }) => {
  return fetch('/youyan/project/internal_share/', {
    method: 'POST',
    body,
  });
};

// 获取相似推荐
export const getSimilarList = (params: { template_id: number }) => {
  return fetch('/youyan/template/recommend_template/', {
    method: 'GET',
    params,
  });
};

// 获取优秀作品相似推荐
export const getSimilarListByUser = (params: {
  // many: number
  // is_personal_excellent_template: number
  page: number;
  page_size: number;
}) => {
  return fetch('/youyan/template/personal_excellent_template/', {
    method: 'GET',
    params,
  });
};

// ]获取单个模板
export const getTemplate = (params: { template_id: number; query_star?: boolean }) => {
  return fetch<IResponse<Template>>('/youyan/template/detail/', {
    method: 'GET',
    params,
  });
};

export const getHomePageOrgTemplate = (params: TemplateParams) => {
  return fetch<IPageResponse<Template>>('/youyan/template/get_homepage_org_template/', {
    method: 'GET',
    params,
  });
};

// 获取模板分享话术
export const getTemplateShareText = (params: { template_id: number }) => {
  return fetch('/promotion_center/application_scene/get_share/', {
    method: 'GET',
    params,
  });
};

// 服务平台用户主页上下架模板
export const putTemplatePersonUpdateStatus = (params: { online_status: number; ids: string }) => {
  return fetch('/youyan/template/person_update_template_status/', {
    method: 'PUT',
    body: params,
  });
};

// 服务平台用户批量撤回模板发布申请
export const posBatchRevertReview = (params: { ids: string }) => {
  return fetch('/youyan/template/batch_revert_review/', {
    method: 'POST',
    body: params,
  });
};

// 服务平台用户批量撤回模板发布申请
export const putBatchPersonUpdateSubmitReview = (params: { ids: string }) => {
  return fetch('/youyan/template/batch_person_update_submit_review/', {
    method: 'PUT',
    body: params,
  });
};

// 个人主页复制到个人空间
// /youyan/my_share/copy_to_personal/
export const postCopyToPersonal = (data: any) => {
  return fetch('/youyan/my_share/copy_to_personal/', {
    method: 'POST',
    body: data,
  });
};

// 获取模板是否收藏
export const getStars = (data: StarRequest) =>
  fetch<IResponse<Star[]>>('/youyan/template/query_is_star/', {
    method: 'GET',
    params: data,
  });

// 作品中心搜索
export const getTemplateSearch = (params: TemplateParams, config?: RequestConfig) => {
  return fetch<IPageResponse<Template, { resolution: string }>>('/youyan/template/search/', {
    method: 'GET',
    params,
    ...config,
  });
};
